// extracted by mini-css-extract-plugin
module.exports = {"title":"title-module--title--1qSQd","glow":"title-module--glow--2ZOfB"};